<div class="body">

    <button mat-icon-button aria-label="Close" (click)="close()" class="btClose">
        <mat-icon svgIcon="close" aria-hidden="false" aria-label="Close"></mat-icon>
    </button>

    <h2 class="mb-20">{{ cookieSettings.cookieSettingsModal }}</h2>
    <div class="mt-20">
        <span class="mt-20 text-body" [innerHTML]="sanitizedHtmlNote"></span>
    </div>

    <div class="flex-row cookie-row mt-20">
        <div class="flex-column cookie-description-column">
            <div class="semi-bold">{{ cookieSettings.cookieFunctional }}</div>
            <div class="grey-90-text subtext-regular">{{ cookieSettings.cookieFunctionalDescriptionText }}</div>
        </div>
        <app-toggle [disabled]="true" [checked]="true" [class.disabled]="true"></app-toggle>
    </div>

    <div class="flex-row cookie-row mt-30">
        <div class="flex-column cookie-description-column">
            <div class="semi-bold">{{ cookieSettings.cookieStatistic }}</div>
            <div class="grey-90-text subtext-regular">{{ cookieSettings.cookieStatisticDescriptionText }}</div>
        </div>
        <app-toggle [(checked)]="statisticCookies"></app-toggle>
    </div>


    <div class="flex-row cookie-row mt-30 mb-20">
        <div class="flex-column cookie-description-column">
            <div class="semi-bold">{{ cookieSettings.cookieMarketing }}</div>
            <div class="grey-90-text subtext-regular">{{ cookieSettings.cookieMarketingDescriptionText }}</div>
        </div>
        <app-toggle [(checked)]="marketingCookies"></app-toggle>
    </div>

    <hr/>

    <app-primary-button class="mt-20 mb-10" [fullWidth]="true" [label]="cookieSettings.cookieBtnModalReject"
                        (click)="onAcceptAllCookies()"></app-primary-button>
    <app-secondary-button [fullWidth]="true" [label]="cookieSettings.cookieBtnModalAccept"
                          (click)="onAcceptSelectedCookies()"></app-secondary-button>

</div>
